import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, ViewChild, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import '@tn-equis/core/utils';
import * as i1 from '@tn-equis/core/services';
import { EquisServicesModule } from '@tn-equis/core/services';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@tn-equis/core/components/button';
import { EquisButtonModule } from '@tn-equis/core/components/button';
import * as i6 from '@tn-equis/core/directives';
import { EquisDirectiveModule } from '@tn-equis/core/directives';
import * as i2$1 from '@tn-equis/core/components/sticker-animation';
import { EquisStickerAnimationModule } from '@tn-equis/core/components/sticker-animation';
import { EquisOverlayComponent, EquisOverlayModule } from '@tn-equis/core/components/overlay';

var EquisModalDialogSizes;
(function (EquisModalDialogSizes) {
    EquisModalDialogSizes["EXTRA_SMALL"] = "extra-small";
    EquisModalDialogSizes["SMALL"] = "small";
    EquisModalDialogSizes["MEDIUM"] = "medium";
    EquisModalDialogSizes["LARGE"] = "large";
    EquisModalDialogSizes["EXTRA_LARGE"] = "extra-large";
})(EquisModalDialogSizes || (EquisModalDialogSizes = {}));
var EquisModalDialogTypes;
(function (EquisModalDialogTypes) {
    EquisModalDialogTypes["CUSTOM"] = "custom";
    EquisModalDialogTypes["ALERT"] = "alert";
})(EquisModalDialogTypes || (EquisModalDialogTypes = {}));
var EquisModalDialogFooterLayout;
(function (EquisModalDialogFooterLayout) {
    EquisModalDialogFooterLayout["HORIZONTAL"] = "horizontal";
    EquisModalDialogFooterLayout["VERTICAL"] = "vertical";
})(EquisModalDialogFooterLayout || (EquisModalDialogFooterLayout = {}));
var EquisModalDialogAlignContentText;
(function (EquisModalDialogAlignContentText) {
    EquisModalDialogAlignContentText["LEFT"] = "left";
    EquisModalDialogAlignContentText["CENTER"] = "center";
})(EquisModalDialogAlignContentText || (EquisModalDialogAlignContentText = {}));

class EquisModalDialogHeaderComponent {
    constructor() {
        this.shadow = false;
        this.crossButton = true;
        this.alignContent = EquisModalDialogAlignContentText.CENTER;
        this.modalDialogHeaderEvents = new EventEmitter();
    }
    get displayAlignContent() {
        if (this.alignContent === 'left') {
            return `modal-dialog__header--align-left`;
        }
        return '';
    }
    closeModalDialog() {
        const closeEvent = {
            event: 'close_button',
            data: {
                text: 'cross_button',
                closeModal: true,
                disabled: false,
            },
        };
        this.modalDialogHeaderEvents.emit(closeEvent);
    }
}
EquisModalDialogHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisModalDialogHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisModalDialogHeaderComponent, selector: "z-modal-dialog-header, equis-modal-dialog-header", inputs: { id: "id", title: "title", shadow: "shadow", crossButton: "crossButton", alignContent: "alignContent" }, outputs: { modalDialogHeaderEvents: "modalDialogHeaderEvents" }, ngImport: i0, template: "<header\n  [attr.id]=\"id\"\n  class=\"modal-dialog__header\"\n  [ngClass]=\"[\n    shadow ? 'modal-dialog__header--shadow' : '',\n    displayAlignContent\n  ]\"\n>\n  <h1 *ngIf=\"title\" class=\"equis-h2-semibold margin-top-24 modal-dialog__title\">\n    {{ title }}\n  </h1>\n  <button\n    *ngIf=\"crossButton\"\n    class=\"modal-dialog__close-button icon\"\n    (click)=\"closeModalDialog()\"\n  >\n    <p class=\"icon-cross size-24\"></p>\n  </button>\n</header>\n", styles: [".modal-dialog__header{padding:24px 48px 0 24px;position:relative}.modal-dialog__header--shadow:after{background:linear-gradient(to bottom,rgba(9,9,9,.2),transparent);border-radius:0;bottom:-16px;content:\"\";height:16px;left:0;pointer-events:none;position:absolute;width:100%}.modal-dialog__header--align-left{text-align:left}.modal-dialog__close-button{background:none;border:0;color:#50007f;cursor:pointer;padding:4px;position:absolute;right:12px;top:12px}.modal-dialog__close-button:focus{background:#fafafa;border-radius:4px;color:#333}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-modal-dialog-header, equis-modal-dialog-header', template: "<header\n  [attr.id]=\"id\"\n  class=\"modal-dialog__header\"\n  [ngClass]=\"[\n    shadow ? 'modal-dialog__header--shadow' : '',\n    displayAlignContent\n  ]\"\n>\n  <h1 *ngIf=\"title\" class=\"equis-h2-semibold margin-top-24 modal-dialog__title\">\n    {{ title }}\n  </h1>\n  <button\n    *ngIf=\"crossButton\"\n    class=\"modal-dialog__close-button icon\"\n    (click)=\"closeModalDialog()\"\n  >\n    <p class=\"icon-cross size-24\"></p>\n  </button>\n</header>\n", styles: [".modal-dialog__header{padding:24px 48px 0 24px;position:relative}.modal-dialog__header--shadow:after{background:linear-gradient(to bottom,rgba(9,9,9,.2),transparent);border-radius:0;bottom:-16px;content:\"\";height:16px;left:0;pointer-events:none;position:absolute;width:100%}.modal-dialog__header--align-left{text-align:left}.modal-dialog__close-button{background:none;border:0;color:#50007f;cursor:pointer;padding:4px;position:absolute;right:12px;top:12px}.modal-dialog__close-button:focus{background:#fafafa;border-radius:4px;color:#333}\n"] }]
        }], propDecorators: { id: [{
                type: Input
            }], title: [{
                type: Input
            }], shadow: [{
                type: Input
            }], crossButton: [{
                type: Input
            }], alignContent: [{
                type: Input
            }], modalDialogHeaderEvents: [{
                type: Output
            }] } });

class EquisModalDialogBodyComponent {
    constructor() {
        this.scrollEvent = new EventEmitter();
    }
    onScroll() {
        const scrollTop = this.modalDialogBody.nativeElement.parentElement.scrollTop;
        const scrollHeight = this.modalDialogBody.nativeElement.parentElement.scrollHeight;
        const contentHeight = this.modalDialogBody.nativeElement.parentElement.clientHeight;
        const scroll = {
            top: scrollTop !== 0,
            bottom: contentHeight + scrollTop - scrollHeight !== 0,
        };
        this.scrollEvent.emit(scroll);
    }
    ngOnInit() {
        const scrollHeight = this.modalDialogBody.nativeElement.parentElement.scrollHeight;
        const contentHeight = this.modalDialogBody.nativeElement.parentElement.clientHeight;
        const scroll = {
            top: false,
            bottom: scrollHeight > contentHeight,
        };
        this.scrollEvent.emit(scroll);
    }
}
EquisModalDialogBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisModalDialogBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisModalDialogBodyComponent, selector: "z-modal-dialog-body, equis-modal-dialog-body", outputs: { scrollEvent: "scrollEvent" }, host: { listeners: { "scroll": "onScroll()" } }, viewQueries: [{ propertyName: "modalDialogBody", first: true, predicate: ["modalDialogBody"], descendants: true, static: true }], ngImport: i0, template: "<div #modalDialogBody>\n  <div class=\"modal-dialog__body-wrapper\"></div>\n</div>\n", styles: [".modal-dialog__body-wrapper{margin-bottom:24px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-modal-dialog-body, equis-modal-dialog-body', template: "<div #modalDialogBody>\n  <div class=\"modal-dialog__body-wrapper\"></div>\n</div>\n", styles: [".modal-dialog__body-wrapper{margin-bottom:24px}\n"] }]
        }], propDecorators: { scrollEvent: [{
                type: Output
            }], modalDialogBody: [{
                type: ViewChild,
                args: ['modalDialogBody', { static: true }]
            }], onScroll: [{
                type: HostListener,
                args: ['scroll', []]
            }] } });

class EquisModalDialogFooterComponent {
    constructor(navigatorService) {
        this.navigatorService = navigatorService;
        this.shadow = false;
        this.footerLayout = EquisModalDialogFooterLayout.HORIZONTAL;
        this.fullModal = false;
        this.modalDialogFooterEvents = new EventEmitter();
    }
    closeModalDialog(button) {
        if (button.closeModal === undefined || button.closeModal) {
            const closeEvent = {
                event: 'close_button',
                data: button,
            };
            this.modalDialogFooterEvents.emit(closeEvent);
        }
    }
    get displayFooterLayout() {
        if (this.footerLayout === 'vertical') {
            return `modal-dialog__column-layout`;
        }
        return '';
    }
    get footerFullModalClassName() {
        if (this.fullModal && this.navigatorService.isMobile) {
            return `modal-dialog__column-layout--fullModalFooter`;
        }
        return '';
    }
    get footerFullModalPadding() {
        if (this.fullModal && this.navigatorService.isMobile) {
            return `modal-dialog__footer--paddingFullModal`;
        }
        return '';
    }
}
EquisModalDialogFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogFooterComponent, deps: [{ token: i1.EquisNavigatorService }], target: i0.ɵɵFactoryTarget.Component });
EquisModalDialogFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisModalDialogFooterComponent, selector: "z-modal-dialog-footer, equis-modal-dialog-footer", inputs: { id: "id", buttonList: "buttonList", shadow: "shadow", footerLayout: "footerLayout", fullModal: "fullModal" }, outputs: { modalDialogFooterEvents: "modalDialogFooterEvents" }, ngImport: i0, template: "<footer\n  [attr.id]=\"id\"\n  class=\"modal-dialog__footer\"\n  [ngClass]=\"[\n    shadow ? 'modal-dialog__footer--shadow' : '',\n    footerFullModalPadding\n  ]\"\n>\n  <div\n    class=\"modal-dialog__footer-wrapper\"\n    [ngClass]=\"[displayFooterLayout, footerFullModalClassName]\"\n  >\n    <ng-container *ngFor=\"let button of buttonList; let i = index\">\n      <equis-button\n        class=\"modal-dialog__button\"\n        [text]=\"button.text\"\n        [type]=\"button.type === undefined ? 'link' : button.type\"\n        [width]=\"button.width === undefined ? '' : button.width\"\n        [disabled]=\"button.disabled\"\n        (buttonEvents)=\"closeModalDialog(button)\"\n      ></equis-button>\n    </ng-container>\n  </div>\n</footer>\n", styles: [".modal-dialog{--buttons-padding-right: 12px}.modal-dialog__footer{display:flex;justify-content:flex-end;padding:27px 24px 16px;position:relative}.modal-dialog__footer--paddingFullModal{padding:125px 24px 16px}.modal-dialog__footer--shadow:after{background:linear-gradient(to top,rgba(9,9,9,.2),transparent);border-radius:0;content:\"\";height:16px;left:0;pointer-events:none;position:absolute;top:-16px;width:100%}.modal-dialog__footer-wrapper{display:flex;justify-content:flex-end;white-space:nowrap;width:100%}.modal-dialog__button{display:flex;justify-content:flex-end;margin-top:-20px;padding-right:var(--buttons-padding-right)}.modal-dialog__button:last-child{padding-right:0}.modal-dialog__column-layout{align-items:flex-end;flex-direction:column;margin-top:-8px;padding:4px;row-gap:32px;--buttons-padding-right: 0}.modal-dialog__column-layout--fullModalFooter{align-items:center;bottom:1em;display:flex;justify-content:center;left:0;padding:0;position:fixed;z-index:100}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i3.EquisButtonComponent, selector: "z-button , equis-button", inputs: ["loading", "disabled", "width", "text", "icon", "iconPos", "type", "size", "id", "fadeBackground", "href", "target", "responsive"], outputs: ["buttonEvents"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-modal-dialog-footer, equis-modal-dialog-footer', template: "<footer\n  [attr.id]=\"id\"\n  class=\"modal-dialog__footer\"\n  [ngClass]=\"[\n    shadow ? 'modal-dialog__footer--shadow' : '',\n    footerFullModalPadding\n  ]\"\n>\n  <div\n    class=\"modal-dialog__footer-wrapper\"\n    [ngClass]=\"[displayFooterLayout, footerFullModalClassName]\"\n  >\n    <ng-container *ngFor=\"let button of buttonList; let i = index\">\n      <equis-button\n        class=\"modal-dialog__button\"\n        [text]=\"button.text\"\n        [type]=\"button.type === undefined ? 'link' : button.type\"\n        [width]=\"button.width === undefined ? '' : button.width\"\n        [disabled]=\"button.disabled\"\n        (buttonEvents)=\"closeModalDialog(button)\"\n      ></equis-button>\n    </ng-container>\n  </div>\n</footer>\n", styles: [".modal-dialog{--buttons-padding-right: 12px}.modal-dialog__footer{display:flex;justify-content:flex-end;padding:27px 24px 16px;position:relative}.modal-dialog__footer--paddingFullModal{padding:125px 24px 16px}.modal-dialog__footer--shadow:after{background:linear-gradient(to top,rgba(9,9,9,.2),transparent);border-radius:0;content:\"\";height:16px;left:0;pointer-events:none;position:absolute;top:-16px;width:100%}.modal-dialog__footer-wrapper{display:flex;justify-content:flex-end;white-space:nowrap;width:100%}.modal-dialog__button{display:flex;justify-content:flex-end;margin-top:-20px;padding-right:var(--buttons-padding-right)}.modal-dialog__button:last-child{padding-right:0}.modal-dialog__column-layout{align-items:flex-end;flex-direction:column;margin-top:-8px;padding:4px;row-gap:32px;--buttons-padding-right: 0}.modal-dialog__column-layout--fullModalFooter{align-items:center;bottom:1em;display:flex;justify-content:center;left:0;padding:0;position:fixed;z-index:100}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.EquisNavigatorService }]; }, propDecorators: { id: [{
                type: Input
            }], buttonList: [{
                type: Input
            }], shadow: [{
                type: Input
            }], footerLayout: [{
                type: Input
            }], fullModal: [{
                type: Input
            }], modalDialogFooterEvents: [{
                type: Output
            }] } });

class EquisModalDialogComponent {
    constructor(keypressService, navigatorService) {
        this.keypressService = keypressService;
        this.navigatorService = navigatorService;
        this.closeOnEscKey = true;
        this.closeOnBackgroundClick = true;
        this.afterClose$ = new Subject();
        this.modalDialogSize = EquisModalDialogSizes.MEDIUM;
        this.headerTopScroll = false;
        this.footerBottomScroll = false;
    }
    set size(size) {
        this.modalDialogSize = Object.values(EquisModalDialogSizes).includes(size)
            ? size
            : EquisModalDialogSizes.MEDIUM;
    }
    ngOnInit() {
        const closeOnEscKey = this.closeOnEscKey;
        this.keypressService$ = this.keypressService
            .keyPressEscape()
            .subscribe((escapePressed) => {
            if (closeOnEscKey && escapePressed === true) {
                const escKey = {
                    event: 'escape_closed',
                };
                this.afterClose$.next(escKey);
            }
        });
    }
    closeModalDialog(response) {
        this.afterClose$.next(response);
    }
    modalDialogClickOutside(targetElement) {
        if (this.closeOnBackgroundClick &&
            this.modalDialogWrapper.nativeElement === targetElement) {
            const clickOutside = {
                event: 'click_outside',
            };
            this.afterClose$.next(clickOutside);
        }
    }
    scroll(scroll) {
        this.headerTopScroll = scroll.top;
        this.footerBottomScroll = scroll.bottom;
    }
    ngOnDestroy() {
        if (this.keypressService$) {
            this.keypressService$.unsubscribe();
        }
    }
    get fullModalClassName() {
        if (this.modalDialogData.fullModal && this.navigatorService.isMobile) {
            return `modal-dialog__fullMobile`;
        }
        return ``;
    }
}
EquisModalDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogComponent, deps: [{ token: i1.EquisKeypressService }, { token: i1.EquisNavigatorService }], target: i0.ɵɵFactoryTarget.Component });
EquisModalDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisModalDialogComponent, selector: "z-modal-dialog, equis-modal-dialog", inputs: { size: "size", closeOnEscKey: "closeOnEscKey", closeOnBackgroundClick: "closeOnBackgroundClick", modalDialogData: "modalDialogData", afterClose$: "afterClose$" }, viewQueries: [{ propertyName: "modalDialogWrapper", first: true, predicate: ["ModalDialogWrapper"], descendants: true, static: true }], ngImport: i0, template: "<div [attr.id]=\"modalDialogData?.id\" class=\"modal-dialog\" #ModalDialogWrapper>\n  <div class=\"container modal-dialog__wrapper\">\n    <div class=\"row center-xs\">\n      <section\n        class=\"modal-dialog__container\"\n        [ngClass]=\"[\n          'modal-dialog__container--' + modalDialogSize,\n          fullModalClassName\n        ]\"\n        EquisOuterClick\n        (clickOutside)=\"modalDialogClickOutside($event)\"\n      >\n        <equis-modal-dialog-header\n          *ngIf=\"modalDialogData?.header\"\n          [id]=\"modalDialogData.header.id\"\n          [title]=\"modalDialogData.header.title\"\n          [shadow]=\"headerTopScroll\"\n          [crossButton]=\"modalDialogData.header.crossButton\"\n          [alignContent]=\"modalDialogData.header.alignContent\"\n          (modalDialogHeaderEvents)=\"closeModalDialog($event)\"\n        >\n        </equis-modal-dialog-header>\n        <equis-modal-dialog-body (scrollEvent)=\"scroll($event)\">\n        </equis-modal-dialog-body>\n        <equis-modal-dialog-footer\n          *ngIf=\"modalDialogData?.footer\"\n          [id]=\"modalDialogData.footer.id\"\n          [buttonList]=\"modalDialogData.footer.buttonList\"\n          [shadow]=\"footerBottomScroll\"\n          [footerLayout]=\"modalDialogData.footer.footerLayout\"\n          [fullModal]=\"modalDialogData.fullModal === true\"\n          (modalDialogFooterEvents)=\"closeModalDialog($event)\"\n        >\n        </equis-modal-dialog-footer>\n      </section>\n    </div>\n  </div>\n</div>\n", styles: [".modal-dialog{align-items:center;display:flex;height:100%;justify-content:center;left:0;position:fixed;top:0;width:100%;z-index:810}.modal-dialog__wrapper{pointer-events:none;width:100%}.modal-dialog equis-modal-dialog-body{overflow:auto}.modal-dialog__container{background:#ffffff;border:1px solid gray;border-radius:16px;box-shadow:0 24px 32px #00000029,0 -20px 32px -20px #0000001f;display:flex;flex-direction:column;max-height:calc(100vh - 128px);max-width:calc(100vw - 32px);overflow:hidden;pointer-events:initial;position:relative;width:100%}.modal-dialog__container--extra-small{width:352px}.modal-dialog__container--small{width:544px}.modal-dialog__container--medium{width:736px}.modal-dialog__container--large{width:928px}.modal-dialog__container--extra-large{width:1120px}.modal-dialog__fullMobile{border-radius:0;height:100vh;max-height:none;max-width:none;width:100vw}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: EquisModalDialogHeaderComponent, selector: "z-modal-dialog-header, equis-modal-dialog-header", inputs: ["id", "title", "shadow", "crossButton", "alignContent"], outputs: ["modalDialogHeaderEvents"] }, { kind: "component", type: EquisModalDialogBodyComponent, selector: "z-modal-dialog-body, equis-modal-dialog-body", outputs: ["scrollEvent"] }, { kind: "component", type: EquisModalDialogFooterComponent, selector: "z-modal-dialog-footer, equis-modal-dialog-footer", inputs: ["id", "buttonList", "shadow", "footerLayout", "fullModal"], outputs: ["modalDialogFooterEvents"] }, { kind: "directive", type: i6.EquisOuterClickDirective, selector: "[zOuterClick], [EquisOuterClick]", inputs: ["disabledClose"], outputs: ["clickOutside"], exportAs: ["zOuterClick", "EquisOuterClick"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-modal-dialog, equis-modal-dialog', template: "<div [attr.id]=\"modalDialogData?.id\" class=\"modal-dialog\" #ModalDialogWrapper>\n  <div class=\"container modal-dialog__wrapper\">\n    <div class=\"row center-xs\">\n      <section\n        class=\"modal-dialog__container\"\n        [ngClass]=\"[\n          'modal-dialog__container--' + modalDialogSize,\n          fullModalClassName\n        ]\"\n        EquisOuterClick\n        (clickOutside)=\"modalDialogClickOutside($event)\"\n      >\n        <equis-modal-dialog-header\n          *ngIf=\"modalDialogData?.header\"\n          [id]=\"modalDialogData.header.id\"\n          [title]=\"modalDialogData.header.title\"\n          [shadow]=\"headerTopScroll\"\n          [crossButton]=\"modalDialogData.header.crossButton\"\n          [alignContent]=\"modalDialogData.header.alignContent\"\n          (modalDialogHeaderEvents)=\"closeModalDialog($event)\"\n        >\n        </equis-modal-dialog-header>\n        <equis-modal-dialog-body (scrollEvent)=\"scroll($event)\">\n        </equis-modal-dialog-body>\n        <equis-modal-dialog-footer\n          *ngIf=\"modalDialogData?.footer\"\n          [id]=\"modalDialogData.footer.id\"\n          [buttonList]=\"modalDialogData.footer.buttonList\"\n          [shadow]=\"footerBottomScroll\"\n          [footerLayout]=\"modalDialogData.footer.footerLayout\"\n          [fullModal]=\"modalDialogData.fullModal === true\"\n          (modalDialogFooterEvents)=\"closeModalDialog($event)\"\n        >\n        </equis-modal-dialog-footer>\n      </section>\n    </div>\n  </div>\n</div>\n", styles: [".modal-dialog{align-items:center;display:flex;height:100%;justify-content:center;left:0;position:fixed;top:0;width:100%;z-index:810}.modal-dialog__wrapper{pointer-events:none;width:100%}.modal-dialog equis-modal-dialog-body{overflow:auto}.modal-dialog__container{background:#ffffff;border:1px solid gray;border-radius:16px;box-shadow:0 24px 32px #00000029,0 -20px 32px -20px #0000001f;display:flex;flex-direction:column;max-height:calc(100vh - 128px);max-width:calc(100vw - 32px);overflow:hidden;pointer-events:initial;position:relative;width:100%}.modal-dialog__container--extra-small{width:352px}.modal-dialog__container--small{width:544px}.modal-dialog__container--medium{width:736px}.modal-dialog__container--large{width:928px}.modal-dialog__container--extra-large{width:1120px}.modal-dialog__fullMobile{border-radius:0;height:100vh;max-height:none;max-width:none;width:100vw}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.EquisKeypressService }, { type: i1.EquisNavigatorService }]; }, propDecorators: { size: [{
                type: Input
            }], closeOnEscKey: [{
                type: Input
            }], closeOnBackgroundClick: [{
                type: Input
            }], modalDialogData: [{
                type: Input
            }], afterClose$: [{
                type: Input
            }], modalDialogWrapper: [{
                type: ViewChild,
                args: ['ModalDialogWrapper', { static: true }]
            }] } });

class EquisModalDialogHeaderModule {
    static forRoot() {
        return {
            ngModule: EquisModalDialogHeaderModule,
        };
    }
}
EquisModalDialogHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisModalDialogHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogHeaderModule, declarations: [EquisModalDialogHeaderComponent], imports: [CommonModule], exports: [EquisModalDialogHeaderComponent] });
EquisModalDialogHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogHeaderModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisModalDialogHeaderComponent],
                    imports: [CommonModule],
                    exports: [EquisModalDialogHeaderComponent],
                }]
        }] });

class EquisModalDialogBodyModule {
    static forRoot() {
        return {
            ngModule: EquisModalDialogBodyModule,
        };
    }
}
EquisModalDialogBodyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogBodyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisModalDialogBodyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogBodyModule, declarations: [EquisModalDialogBodyComponent], imports: [CommonModule], exports: [EquisModalDialogBodyComponent] });
EquisModalDialogBodyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogBodyModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogBodyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisModalDialogBodyComponent],
                    imports: [CommonModule],
                    exports: [EquisModalDialogBodyComponent],
                }]
        }] });

class EquisModalDialogFooterModule {
    static forRoot() {
        return {
            ngModule: EquisModalDialogFooterModule,
        };
    }
}
EquisModalDialogFooterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogFooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisModalDialogFooterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogFooterModule, declarations: [EquisModalDialogFooterComponent], imports: [CommonModule, EquisButtonModule], exports: [EquisModalDialogFooterComponent] });
EquisModalDialogFooterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogFooterModule, imports: [CommonModule, EquisButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogFooterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisModalDialogFooterComponent],
                    imports: [CommonModule, EquisButtonModule],
                    exports: [EquisModalDialogFooterComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
                }]
        }] });

class EquisModalDialogAlertComponent {
    constructor() {
        this.defaultStickerSize = 100;
        this.alignContent = EquisModalDialogAlignContentText.CENTER;
    }
    get displayAlignContent() {
        if (this.modalDialogData.alignContent === 'left') {
            return `dialog__alignContent`;
        }
        return '';
    }
    get displayAlignContentWrapper() {
        if (this.modalDialogData.alignContent === 'left') {
            return `dialog__wrapper--alignContentWrapper`;
        }
        return '';
    }
    get width() {
        let width = this.modalDialogData.sticker.width;
        if (width === undefined) {
            width = this.defaultStickerSize;
        }
        return width;
    }
    get height() {
        let width = this.modalDialogData.sticker.height;
        if (width === undefined) {
            width = this.defaultStickerSize;
        }
        return width;
    }
}
EquisModalDialogAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogAlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisModalDialogAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisModalDialogAlertComponent, selector: "z-modal-dialog-alert, equis-modal-dialog-alert", inputs: { modalDialogData: "modalDialogData" }, ngImport: i0, template: "<div\n  [attr.id]=\"modalDialogData.id\"\n  class=\"dialog__wrapper\"\n  [ngClass]=\"[\n    displayAlignContentWrapper,\n    modalDialogData?.sticker ? '' : 'dialog__wrapper--without-sticker'\n  ]\"\n>\n  <equis-sticker-animation\n    *ngIf=\"modalDialogData?.sticker\"\n    [autoPlay]=\"true\"\n    [loop]=\"modalDialogData.sticker.loop\"\n    [width]=\"width\"\n    [height]=\"height\"\n    [path]=\"modalDialogData.sticker.path\"\n    class=\"dialog__sticker\"\n  >\n  </equis-sticker-animation>\n  <header\n    *ngIf=\"modalDialogData?.title\"\n    class=\"dialog__title equis-h2-semibold\"\n    [ngClass]=\"displayAlignContent\"\n  >\n    {{ modalDialogData.title }}\n  </header>\n  <p\n    *ngIf=\"modalDialogData?.message\"\n    class=\"dialog__message equis-body-1\"\n    [ngClass]=\"displayAlignContent\"\n  >\n    {{ modalDialogData.message }}\n  </p>\n</div>\n", styles: [".dialog__wrapper{align-items:center;display:flex;flex-direction:column;margin:24px}.dialog__wrapper--alignContentWrapper{align-items:flex-start;display:flex}.dialog__wrapper--without-sticker{margin-top:0}.dialog__sticker{height:72px;position:relative;top:-14px}.dialog__title{margin-top:22px}.dialog__message{margin-top:18px}.dialog__alignContent{text-align:left}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.EquisStickerAnimationComponent, selector: "z-sticker-animation, equis-sticker-animation", inputs: ["autoPlay", "loop", "path", "width", "height"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-modal-dialog-alert, equis-modal-dialog-alert', template: "<div\n  [attr.id]=\"modalDialogData.id\"\n  class=\"dialog__wrapper\"\n  [ngClass]=\"[\n    displayAlignContentWrapper,\n    modalDialogData?.sticker ? '' : 'dialog__wrapper--without-sticker'\n  ]\"\n>\n  <equis-sticker-animation\n    *ngIf=\"modalDialogData?.sticker\"\n    [autoPlay]=\"true\"\n    [loop]=\"modalDialogData.sticker.loop\"\n    [width]=\"width\"\n    [height]=\"height\"\n    [path]=\"modalDialogData.sticker.path\"\n    class=\"dialog__sticker\"\n  >\n  </equis-sticker-animation>\n  <header\n    *ngIf=\"modalDialogData?.title\"\n    class=\"dialog__title equis-h2-semibold\"\n    [ngClass]=\"displayAlignContent\"\n  >\n    {{ modalDialogData.title }}\n  </header>\n  <p\n    *ngIf=\"modalDialogData?.message\"\n    class=\"dialog__message equis-body-1\"\n    [ngClass]=\"displayAlignContent\"\n  >\n    {{ modalDialogData.message }}\n  </p>\n</div>\n", styles: [".dialog__wrapper{align-items:center;display:flex;flex-direction:column;margin:24px}.dialog__wrapper--alignContentWrapper{align-items:flex-start;display:flex}.dialog__wrapper--without-sticker{margin-top:0}.dialog__sticker{height:72px;position:relative;top:-14px}.dialog__title{margin-top:22px}.dialog__message{margin-top:18px}.dialog__alignContent{text-align:left}\n"] }]
        }], propDecorators: { modalDialogData: [{
                type: Input
            }] } });

class EquisModalDialogBaseService {
    constructor(componentInsertionService, appRef) {
        this.componentInsertionService = componentInsertionService;
        this.appRef = appRef;
        this.afterClose$ = new Subject();
        this._modalDialogId = [];
        this._modalDialogData = 'modalDialogData';
        this._modalDialogSize = 'size';
        this._modalDialogCloseOnEscKey = 'closeOnEscKey';
        this._modalDialogCloseOnBackgroundClick = 'closeOnBackgroundClick';
        this._modalAfterClose = 'afterClose$';
    }
    showModalDialog(modalDialogConfig, closeSubject$, customComponent) {
        let parentModalDialog;
        this.afterClose$ = closeSubject$;
        this._modalDialogId.push(this.componentInsertionService.create(EquisModalDialogComponent, document.body));
        const lastIndexModalDialogId = this._modalDialogId.length - 1;
        this.componentInsertionService.getComponentInstance(this._modalDialogId[lastIndexModalDialogId]);
        this.setModalDialogInputs(modalDialogConfig, closeSubject$);
        this._componentToInsert = this.getComponentToInsert(modalDialogConfig.type, customComponent);
        // TODO: Encontrar forma alternativa de obtener el elemento html del body donde se insertará el nuevo componente.
        const bodyList = document.querySelectorAll('equis-modal-dialog-body');
        parentModalDialog = bodyList[bodyList.length - 1].children[0]
            .children[0];
        this._bodyId = this.componentInsertionService.create(this._componentToInsert, parentModalDialog);
        this.componentInsertionService.setProperty(this._bodyId, this._modalDialogData, modalDialogConfig.data.body);
        this.appRef.tick();
    }
    getComponentToInsert(type, customComponent) {
        let componentToInsert = null;
        switch (type) {
            case EquisModalDialogTypes.ALERT:
                componentToInsert = EquisModalDialogAlertComponent;
                break;
            case EquisModalDialogTypes.CUSTOM:
                if (!customComponent) {
                    console.error('CustomComponent es nulo. Verifique por favor.');
                    return;
                }
                componentToInsert = customComponent;
                break;
            default:
                console.error('Verifique el valor del atributo "type".');
                break;
        }
        return componentToInsert;
    }
    setModalDialogInputs(modalDialogConfig, closeSubject) {
        const lastIndexModalDialogId = this._modalDialogId.length - 1;
        this.componentInsertionService.setProperty(this._modalDialogId[lastIndexModalDialogId], this._modalDialogSize, modalDialogConfig.size);
        const closeOnEscKey = modalDialogConfig.closeOnEscKey === undefined ||
            modalDialogConfig.closeOnEscKey;
        this.componentInsertionService.setProperty(this._modalDialogId[lastIndexModalDialogId], this._modalDialogCloseOnEscKey, closeOnEscKey);
        const closeOnBackgroundClick = modalDialogConfig.closeOnBackgroundClick === undefined ||
            modalDialogConfig.closeOnBackgroundClick;
        this.componentInsertionService.setProperty(this._modalDialogId[lastIndexModalDialogId], this._modalDialogCloseOnBackgroundClick, closeOnBackgroundClick);
        this.componentInsertionService.setProperty(this._modalDialogId[lastIndexModalDialogId], this._modalDialogData, modalDialogConfig.data);
        this.componentInsertionService.setProperty(this._modalDialogId[lastIndexModalDialogId], this._modalAfterClose, closeSubject);
    }
    closeModalDialog() {
        const lastIndexModalDialogId = this._modalDialogId.length - 1;
        this.componentInsertionService.destroy(this._modalDialogId[lastIndexModalDialogId]);
        this._modalDialogId.pop();
    }
}
EquisModalDialogBaseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogBaseService, deps: [{ token: i1.EquisComponentInsertionService }, { token: i0.ApplicationRef }], target: i0.ɵɵFactoryTarget.Injectable });
EquisModalDialogBaseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogBaseService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogBaseService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.EquisComponentInsertionService }, { type: i0.ApplicationRef }]; } });

class EquisModalDialogOverlayService {
    constructor(componentInsertionService) {
        this.componentInsertionService = componentInsertionService;
        this._overlayCount = 0;
    }
    showOverlay() {
        if (this._overlayCount === 0) {
            this._overlayId = this.componentInsertionService.create(EquisOverlayComponent, document.body);
            this._overlayInstance =
                this.componentInsertionService.getComponentInstance(this._overlayId);
        }
        else {
            this._overlayInstance.instance.increaseOpacity();
        }
        this._overlayCount += 1;
    }
    closeOverlay() {
        this._overlayCount -= 1;
        if (this._overlayCount === 0) {
            this.componentInsertionService.destroy(this._overlayId);
        }
        else {
            this._overlayInstance.instance.decreaseOpacity();
        }
    }
}
EquisModalDialogOverlayService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogOverlayService, deps: [{ token: i1.EquisComponentInsertionService }], target: i0.ɵɵFactoryTarget.Injectable });
EquisModalDialogOverlayService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogOverlayService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogOverlayService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.EquisComponentInsertionService }]; } });

class EquisModalDialogService {
    constructor(_modalDialogBaseService, _modalDialogOverlayService) {
        this._modalDialogBaseService = _modalDialogBaseService;
        this._modalDialogOverlayService = _modalDialogOverlayService;
        this._closeSubjectList$ = [];
    }
    /*Importante: 'modalDialogConfig: IEquisModalDialogConfig' es una estructura obligatoria que debe implementar todo modal dialog,
       ya sean nativos o creados por el usuario */
    showModalDialog(modalDialogConfig, customComponent) {
        // Overlay
        this._modalDialogOverlayService.showOverlay();
        // ModalDialog
        this._closeSubjectList$.push(new Subject());
        const subjectListLength = this._closeSubjectList$.length - 1;
        this._closeSubjectList$[subjectListLength].subscribe(() => {
            this.closeModalDialogInternal();
        });
        this._modalDialogBaseService.showModalDialog(modalDialogConfig, this._closeSubjectList$[subjectListLength], customComponent);
        return this._closeSubjectList$[subjectListLength];
    }
    closeModalDialogInternal() {
        this._modalDialogOverlayService.closeOverlay();
        const subjectListLength = this._closeSubjectList$.length - 1;
        this._closeSubjectList$[subjectListLength].unsubscribe();
        this._closeSubjectList$.pop();
        this._modalDialogBaseService.closeModalDialog();
    }
    closeModalDialog(returnData) {
        const subjectListLength = this._closeSubjectList$.length - 1;
        this._closeSubjectList$[subjectListLength].next(returnData);
    }
}
EquisModalDialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogService, deps: [{ token: EquisModalDialogBaseService }, { token: EquisModalDialogOverlayService }], target: i0.ɵɵFactoryTarget.Injectable });
EquisModalDialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: EquisModalDialogBaseService }, { type: EquisModalDialogOverlayService }]; } });

class EquisModalDialogComponentModule {
    static forRoot() {
        return {
            ngModule: EquisModalDialogComponentModule,
        };
    }
}
EquisModalDialogComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisModalDialogComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogComponentModule, declarations: [EquisModalDialogComponent], imports: [CommonModule,
        EquisModalDialogHeaderModule,
        EquisModalDialogBodyModule,
        EquisModalDialogFooterModule,
        EquisDirectiveModule,
        EquisServicesModule] });
EquisModalDialogComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogComponentModule, providers: [EquisModalDialogService], imports: [CommonModule,
        EquisModalDialogHeaderModule,
        EquisModalDialogBodyModule,
        EquisModalDialogFooterModule,
        EquisDirectiveModule,
        EquisServicesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisModalDialogComponent],
                    imports: [
                        CommonModule,
                        EquisModalDialogHeaderModule,
                        EquisModalDialogBodyModule,
                        EquisModalDialogFooterModule,
                        EquisDirectiveModule,
                        EquisServicesModule,
                    ],
                    providers: [EquisModalDialogService],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
                }]
        }] });

class EquisModalDialogAlertModule {
    static forRoot() {
        return {
            ngModule: EquisModalDialogAlertModule,
        };
    }
}
EquisModalDialogAlertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogAlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisModalDialogAlertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogAlertModule, declarations: [EquisModalDialogAlertComponent], imports: [CommonModule, EquisStickerAnimationModule], exports: [EquisModalDialogAlertComponent] });
EquisModalDialogAlertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogAlertModule, imports: [CommonModule, EquisStickerAnimationModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisModalDialogAlertComponent],
                    imports: [CommonModule, EquisStickerAnimationModule],
                    exports: [EquisModalDialogAlertComponent],
                }]
        }] });

class EquisModalDialogModule {
    static forRoot() {
        return {
            ngModule: EquisModalDialogModule,
        };
    }
}
EquisModalDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisModalDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogModule, imports: [CommonModule,
        EquisModalDialogAlertModule,
        EquisModalDialogComponentModule,
        EquisOverlayModule] });
EquisModalDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogModule, providers: [
        EquisModalDialogService,
        EquisModalDialogBaseService,
        EquisModalDialogOverlayService,
    ], imports: [CommonModule,
        EquisModalDialogAlertModule,
        EquisModalDialogComponentModule,
        EquisOverlayModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        EquisModalDialogAlertModule,
                        EquisModalDialogComponentModule,
                        EquisOverlayModule,
                    ],
                    providers: [
                        EquisModalDialogService,
                        EquisModalDialogBaseService,
                        EquisModalDialogOverlayService,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
                }]
        }] });

/*
 * Public API Surface of equis-modal-dialog
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisModalDialogAlertComponent, EquisModalDialogAlertModule, EquisModalDialogAlignContentText, EquisModalDialogBaseService, EquisModalDialogBodyComponent, EquisModalDialogBodyModule, EquisModalDialogComponent, EquisModalDialogComponentModule, EquisModalDialogFooterComponent, EquisModalDialogFooterLayout, EquisModalDialogFooterModule, EquisModalDialogHeaderComponent, EquisModalDialogHeaderModule, EquisModalDialogModule, EquisModalDialogOverlayService, EquisModalDialogService, EquisModalDialogSizes, EquisModalDialogTypes };
